import React from 'react';
import styled from 'styled-components';
import { isSearchEnhancementsMilestone1Enabled } from 'feature-flags';
import * as grid from 'view/styles/grid';
import Button from '@atlaskit/button';
import SearchIcon from '@atlaskit/icon/glyph/search';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { ExpandingButton } from '@atlassian/help-center-common-component/expanding-button';

export interface Props {
    shown: boolean;
    onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export const SearchButton = React.forwardRef(({ shown, onClick }: Props, ref: React.RefObject<HTMLButtonElement>) => {
    return (
        <>
            {isSearchEnhancementsMilestone1Enabled() ? (
                <StyledSearchIconContainer>
                    <Button
                        style={{ borderRadius: '50%' }}
                        ref={ref}
                        onClick={onClick}
                        appearance="subtle"
                        shouldFitContainer
                        iconBefore={
                            <SearchIcon size="medium" label="Search" primaryColor={token('color.icon', colors.N500)} />
                        }
                        analyticsContext={{ actionSubjectId: 'navbarSearch' }}
                    />
                </StyledSearchIconContainer>
            ) : (
                <IconContainer>
                    <CustomIconSizeExpandingButton expanded={shown} onClick={onClick} actionSubjectId="navbarSearch">
                        <SearchIcon size="medium" label="Search" primaryColor={token('color.icon', colors.N500)} />
                    </CustomIconSizeExpandingButton>
                </IconContainer>
            )}
        </>
    );
});

SearchButton.displayName = 'SearchButton';

export default SearchButton;

const ICON_HEIGHT = (grid.unitless / 2) * 5;

const CustomIconSizeExpandingButton = styled(ExpandingButton)`
    /* This is trying ensure we dip into the actual atlaskit icon element atm. No nice hook right now. */
    span > span,
    svg {
        height: ${ICON_HEIGHT}px;
        width: ${ICON_HEIGHT}px;
    }
`;

const IconContainer = styled.span`
    padding-right: ${token('space.100', '8px')};
    border-radius: 50%;
    display: flex;
    overflow: visible;
    position: relative;
`;

const StyledSearchIconContainer = styled.div`
    display: flex;
    height: ${token('space.400', '32px')};
    width: ${token('space.400', '32px')};
    align-items: stretch;
    background-color: ${token('elevation.surface.overlay', colors.N30)};
    border-radius: 50%;
    flex-direction: column;
    justify-content: center;
    transform: translateZ(0);
    transition: transform 200ms, opacity 200ms;
    box-shadow: ${token('space.0', '0px')} ${token('space.0', '0px')} ${token('space.0', '0px')}
        ${token('space.025', '2px')} ${token('color.border.inverse', colors.N0)};
    border: none;
    margin: ${token('space.150', '12px')};
    padding: 0;
    cursor: pointer;
`;
